import { debounceTime, Observable, throttleTime } from 'rxjs';

/**
 *@description
 * decides witch delaying method should be used according to parameters supplied
 * by simpleField directive consumer.
 * if throttleInterval parameter has value, we will invoke throttleTime operator
 * else we will call debounceTime with debounceInterval value or zero.
 * @returns OperatorFunction<[T, T], [any, any]>
 */

export function preferThrottleInterval<T>(throttleInterval: number, debounceInterval: number = 0) {
  return (source$: Observable<T>) =>
    source$.pipe(
      !!throttleInterval ? throttleTime(throttleInterval, null, { leading: false, trailing: true }) : debounceTime(debounceInterval)
    );
}
